import { FilterValues } from '../Store/Filter/state';
import { Filter } from '../Enum/Filters';
import { Period } from '../Interface/Interest/Period';
import { initialState } from '../Store/Filter/reducer';
import { arraysOfStringsAreDifferent } from './Array';
import { arePeriodArraysEqual } from './Interest/PeriodHelper';

const ensureStringsAreEqual = (stringA: string, stringB: string): void => {
    if (stringA !== stringB) {
        throw new Error('Values are not equal');
    }
};

const ensureArraysAreEqual = (arrayA: string[], arrayB: string[]): void => {
    if (arraysOfStringsAreDifferent(arrayA, arrayB)) {
        throw new Error('Values are not equal');
    }
};

const ensurePeriodArraysAreEqual = (arrayA: Period[], arrayB: Period[]): void => {
    if (!arePeriodArraysEqual(arrayA, arrayB)) {
        throw new Error('Values are not equal');
    }
};

export const compareFilterValuesWithInitial = (values: FilterValues): boolean => {
    try {
        for (const [key, value] of Object.entries(values)) {
            if (key === Filter.ModificationLoanForm || key === Filter.Label) {
                continue;
            }

            if (key === Filter.FixedPeriods) {
                ensurePeriodArraysAreEqual(initialState.filterValues[key as Filter] as Period[], value);
                continue;
            }

            if (typeof initialState.filterValues[key as Filter] === 'object') {
                ensureArraysAreEqual(initialState.filterValues[key as Filter] as string[], value);
            }
            if (typeof initialState.filterValues[key as Filter] === 'string') {
                ensureStringsAreEqual(initialState.filterValues[key as Filter] as string, value);
            }
        }
    } catch (e) {
        return false;
    }

    return true;
};
